import {useEffect, useState} from "react";
import "./FboxWikipedia.css";

function FboxWikipedia() {
    const [sections, setSections] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const fetchMarkdown = async () => {
            try {
                const res = await fetch(
                    "https://raw.githubusercontent.com/abdullo211/fiscal_document/master/Errors.md"
                );
                const text = await res.text();
                const lines = text.split("\n");

                const parsedSections = [];
                let currentTitle = "";
                let currentRows = [];

                lines.forEach((line) => {
                    if (line.trim() === "") return;

                    if (!line.startsWith("|")) {
                        // new section
                        if (currentRows.length > 0) {
                            // skip first 2 rows of previous table
                            parsedSections.push({
                                title: currentTitle,
                                rows: currentRows.slice(2) // <- skip first 2 rows
                            });
                        }
                        currentTitle = line.trim();
                        currentRows = [];
                    } else {
                        const cols = line
                            .split("|")
                            .map((col) => col.trim())
                            .filter((col) => col !== "");
                        currentRows.push({
                            id: cols[0] || "",
                            code: cols[1] || "",
                            errorCode: cols[2] || "",
                            descriptionEN: cols[3] || "",
                            descriptionRU: cols[4] || "",
                            descriptionUZ: cols[5] || "",
                        });
                    }
                });

                if (currentRows.length > 0) {
                    parsedSections.push({
                        title: currentTitle,
                        rows: currentRows.slice(2), // skip first 2 rows
                    });
                }

                if (currentRows.length > 0) {
                    parsedSections.push({title: currentTitle, rows: currentRows});
                }

                setSections(parsedSections);
            } catch (err) {
                console.error(err);
            }
        };

        fetchMarkdown();
    }, []);

    const highlightText = (text) => {
        if (!searchQuery) return text;
        const regex = new RegExp(`(${searchQuery})`, "gi");
        return text.replace(regex, "<mark>$1</mark>");
    };

    const filteredSections = sections.map((section) => {
        const filteredRows = section.rows.filter((row) =>
            Object.values(row).some((val) =>
                val.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        return {...section, rows: filteredRows};
    });

    return (
        <div className="page-container">
            <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
            />

            {filteredSections.map(
                (section, idx) =>
                    section.rows.length > 0 && (
                        <div key={idx} className="section">
                            <h2>{section.title}</h2>
                            <table className="custom-table">
                                <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Code</th>
                                    <th>Error Code</th>
                                    <th>Description (EN)</th>
                                    <th>Description (RU)</th>
                                    <th>Description (UZ)</th>
                                </tr>
                                </thead>
                                <tbody>
                                {section.rows.map((row, i) => (
                                    <tr key={i}>
                                        <td
                                            dangerouslySetInnerHTML={{
                                                __html: highlightText(row.id),
                                            }}
                                        />
                                        <td
                                            dangerouslySetInnerHTML={{
                                                __html: highlightText(row.code),
                                            }}
                                        />
                                        <td
                                            dangerouslySetInnerHTML={{
                                                __html: highlightText(row.errorCode),
                                            }}
                                        />
                                        <td
                                            dangerouslySetInnerHTML={{
                                                __html: highlightText(row.descriptionEN),
                                            }}
                                        />
                                        <td
                                            dangerouslySetInnerHTML={{
                                                __html: highlightText(row.descriptionRU),
                                            }}
                                        />
                                        <td
                                            dangerouslySetInnerHTML={{
                                                __html: highlightText(row.descriptionUZ),
                                            }}
                                        />
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )
            )}
        </div>
    );
}

export default FboxWikipedia;
